export const PictureViewStyles = {
    header: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end'
    },
    imageView: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    imageArea: {
        position: 'relative',
        maxHeight: 440,
        maxWidth: 760,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    canvasImage: {
        position: 'relative',
        maxHeight: 'inherit',
        maxWidth: '100%',
        userDrag: 'none',
        userSelect: 'none',
        '-o-user-select': 'none',
        '-moz-user-select': 'none',
        '-webkit-user-drag': 'none',
        '-khtml-user-select': 'none',
        '-webkit-user-select': 'none'
    },
    spacedContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    defaultFont: {
        fontFamily: 'Roboto, Arial, Sans-serif',
        fontSize: '14px'
    },
    pageNavigation: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        marginTop: '8px',
        marginBottom: '8px'
    },
    fullscreenModal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    fullscreenContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
        outline: 'none'
    },
    fullscreenImage: {
        width: '95vw',
        height: '85vh',
        objectFit: 'contain'
    },
    fullscreenCloseButton: {
        position: 'absolute',
        top: 20,
        right: 20,
        backgroundColor: 'white',
        color: 'black',
        border: '1px solid #ddd',
        padding: 8,
        '&:hover': {
            backgroundColor: '#f5f5f5'
        }
    },
    fullscreenPageNavigation: {
        position: 'absolute',
        top: 20,
        left: '50%',
        transform: 'translateX(-50%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '10px'
    },
    fullscreenNavButton: {
        backgroundColor: 'white',
        color: 'black',
        border: '1px solid #ddd',
        padding: 8,
        '&:hover': {
            backgroundColor: '#f5f5f5'
        },
        '&.Mui-disabled': {
            backgroundColor: '#e0e0e0',
            color: 'rgba(0, 0, 0, 0.3)'
        }
    },
    fullscreenPageText: {
        color: 'white',
        fontFamily: 'Roboto, Arial, Sans-serif',
        fontSize: '18px'
    }
};
